import {Check} from '@sparkware/app-utils';
const overrideJson = require('json-override');

export function decodeUriComponentRecursive(url: string): string {
  if(!url) {
    return url
  }

  let decodedUrl = decodeURIComponent(url);

  while(url !== decodedUrl) {
    url = decodedUrl;
    decodedUrl = decodeURIComponent(url);
  }

  return decodedUrl;

}

function safeUriEncode(url: string): string {
  if(!url) {
    return url;
  }

  try {
    return encodeURI(url);
  } catch (err) {
    console.error(`Failed to URI encode the following string: ${url}`);
    return url;
  }


}

function encodeUriPropsForObject(obj: any): any {
  let clone = overrideJson({}, obj);

  Object.keys(clone).forEach(propName => {
    clone[propName] = encodeUriRecursive(clone[propName]);
  });

  return clone;
}

function encodeUriPropsForArray(arr: any): any {
  let clone = [...arr];
  for(let i = 0; i < clone.length; i++) {
    clone[i] = encodeUriRecursive(clone[i]);
  }
  return clone;
}


export function encodeUriRecursive(value: any): any {

  if(Check.isString(value)) {
    return safeUriEncode(value);
  } else if(Check.isObject(value)) {
    return encodeUriPropsForObject(value);
  } else if(Check.isArray(value)) {
    return encodeUriPropsForArray(value);
  } else {
    return value;
  }
}

export function joinUrlParts(baseUrl: string, path: string, hash?: string): string {
  let urlBuilder = new URL(baseUrl);

  if(path) {
      if (!path.startsWith('/')) {
          path = '/' + path;
      }
      urlBuilder.pathname = (urlBuilder.pathname + path).replace('//', '/');
  }

  urlBuilder.hash = hash || '';
  return urlBuilder.href;
}

export function addQueryParam(url: string, queryParam: string): string {
    return url?.includes('?') ? (url + '&' + queryParam) : (url + '?' + queryParam);
}

export function isAbsolutUrl(url: string): boolean {
    if(url.startsWith('#')) {
        return false;
    }

    try {
        new URL(url);
        return true;
    } catch (err) {
        return false;
    }
}